import {
	Component,
	ViewEncapsulation,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	ChangeDetectionStrategy
} from "@angular/core";
import { makeDateUtils } from "../utils/DateUtils";

import * as _moment from "moment";

@Component({
	selector: "rbc-datepicker-year",
	templateUrl: "./datepicker-year.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatepickerYearComponent {
	@Input() id;
	@Input() showYearView: Boolean;
	@Input() selectedDate: Date;
	@Input() pageDate: Date;
	@Input() pageTimestamp: Number;
	@Input() disabledDates: Object;
	@Input() calendarClass: any;
	@Input() calendarStyle: Object;
	@Input() translation: Object;
	@Input() isRtl: Boolean;
	@Input() useUtc: Boolean;
	@Input() highlighted: Object;

	@Output() selectYearEmit = new EventEmitter();
	@Output() changedDecadeEmit = new EventEmitter();

	@ViewChild("yearContainer", { static: false }) yearContainer: ElementRef;

	constructedDateUtils = makeDateUtils(this.useUtc);
	utils = this.constructedDateUtils;

	years() {
		const d = this.pageDate;
		let years = [];
		// set up a new date object to the beginning of the current 'page'7
		let dObj = this.useUtc
			? new Date(
				Date.UTC(
					Math.floor(d.getUTCFullYear() / 10) * 10,
					d.getUTCMonth(),
					d.getUTCDate()
				)
			)
			: new Date(
				Math.floor(d.getFullYear() / 10) * 10,
				d.getMonth(),
				d.getDate(),
				d.getHours(),
				d.getMinutes()
			);
		for (let i = 0; i < 10; i++) {
			years.push({
				year: this.utils.getFullYear(dObj),
				timestamp: dObj.getTime(),
				isSelected: this.isSelectedYear(dObj),
				isDisabled: this.isDisabledYear(dObj)
			});
			this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
		}
		return years;
	}

	getPageDecade() {
		const decadeStart =
			Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
		const decadeEnd = decadeStart + 9;
		const yearSuffix = this.translation["yearSuffix"];
		return `${decadeStart} - ${decadeEnd}${yearSuffix}`;
	}

	isLeftNavDisabled() {
		return this.isRtl
			? this.isNextDecadeDisabled(this.pageTimestamp)
			: this.isPreviousDecadeDisabled(this.pageTimestamp);
	}

	/**
	 * Is the right hand navigation button disabled?
	 */
	isRightNavDisabled() {
		return this.isRtl
			? this.isPreviousDecadeDisabled(this.pageTimestamp)
			: this.isNextDecadeDisabled(this.pageTimestamp);
	}

	selectYear(year) {
		if (year.isDisabled) {
			return false;
		}
		this.selectYearEmit.emit(year);
	}

	changeYear(incrementBy) {
		let date = this.pageDate;
		this.utils.setFullYear(
			date,
			this.utils.getFullYear(date) + incrementBy
		);
		this.changedDecadeEmit.emit(date);
	}

	previousDecade() {
		if (this.isPreviousDecadeDisabled()) {
			return false;
		}
		this.changeYear(-10);
	}

	isPreviousDecadeDisabled(date?) {
		if (!this.disabledDates || !this.disabledDates["to"]) {
			return false;
		}
		const disabledYear = this.utils.getFullYear(this.disabledDates["to"]);
		const lastYearInPreviousPage =
			Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
		return disabledYear > lastYearInPreviousPage;
	}

	nextDecade() {
		if (this.isNextDecadeDisabled()) {
			return false;
		}
		this.changeYear(10);
	}

	isNextDecadeDisabled(date?) {
		if (!this.disabledDates || !this.disabledDates["from"]) {
			return false;
		}
		const disabledYear = this.utils.getFullYear(this.disabledDates["from"]);
		const firstYearInNextPage =
			Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
		return disabledYear < firstYearInNextPage;
	}

	/**
	 * Whether the selected date is in this year
	 */
	isSelectedYear(date) {
		return (
			this.selectedDate &&
			this.utils.getFullYear(this.selectedDate) ===
			this.utils.getFullYear(date)
		);
	}

	/**
	 * Whether a year is disabled
	 */
	isDisabledYear(date) {
		let disabledDates = false;
		if (typeof this.disabledDates === "undefined" || !this.disabledDates) {
			return false;
		}

		if (
			typeof this.disabledDates["to"] !== "undefined" &&
			this.disabledDates["to"]
		) {
			if (
				this.utils.getFullYear(date) <
				this.utils.getFullYear(this.disabledDates["to"])
			) {
				disabledDates = true;
			}
		}
		if (
			typeof this.disabledDates["from"] !== "undefined" &&
			this.disabledDates["from"]
		) {
			if (
				this.utils.getFullYear(date) >
				this.utils.getFullYear(this.disabledDates["from"])
			) {
				disabledDates = true;
			}
		}

		if (
			typeof this.disabledDates["customPredictor"] === "function" &&
			this.disabledDates["customPredictor(date)"]
		) {
			disabledDates = true;
		}

		return disabledDates;
	}

	prevent(event) {
		event.stopPropagation();
	}
}
